const SESSION_MEMORY_KEYS = Object.freeze({
  customer: "customer",
  whitelabel: "whitelabel",
});

const WHITELABEL_STORAGE_KEY = "ll_whitelabel";

function getWhitelabelFromStorage() {
  try {
    const raw = sessionStorage.getItem(WHITELABEL_STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (_) {
    // ignore parse errors
  }
  return null;
}

function setWhitelabelToStorage(value) {
  try {
    if (value === null || value === undefined) {
      sessionStorage.removeItem(WHITELABEL_STORAGE_KEY);
    } else {
      sessionStorage.setItem(WHITELABEL_STORAGE_KEY, JSON.stringify(value));
    }
  } catch (_) {
    // ignore storage errors (e.g., quota exceeded, private mode)
  }
}

const sessionMemory = {
  [SESSION_MEMORY_KEYS.whitelabel]: getWhitelabelFromStorage(),
};

const listeners = new Set();

function notifyListeners() {
  listeners.forEach((listener) => {
    try {
      listener({ ...sessionMemory });
    } catch (_) {
      // ignore listener errors to avoid breaking state updates
    }
  });
}

function parseIfString(value) {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch (_) {
    return null;
  }
}

export function subscribeSessionMemory(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getCustomerFromMemory() {
  return sessionMemory[SESSION_MEMORY_KEYS.customer];
}

export function setCustomerInMemory(value) {
  sessionMemory[SESSION_MEMORY_KEYS.customer] = parseIfString(value);
  notifyListeners();
}

export function removeCustomerFromMemory() {
  sessionMemory[SESSION_MEMORY_KEYS.customer] = null;
  notifyListeners();
}

export function getWhitelabelFromMemory() {
  return sessionMemory[SESSION_MEMORY_KEYS.whitelabel];
}

export function setWhitelabelInMemory(value) {
  const parsed = parseIfString(value);
  sessionMemory[SESSION_MEMORY_KEYS.whitelabel] = parsed;
  setWhitelabelToStorage(parsed);
  notifyListeners();
}

export function removeWhitelabelFromMemory() {
  sessionMemory[SESSION_MEMORY_KEYS.whitelabel] = null;
  notifyListeners();
}

export function hydrateSessionMemory({ customer, whitelabel } = {}) {
  if (customer !== undefined) {
    sessionMemory[SESSION_MEMORY_KEYS.customer] = parseIfString(customer);
  }
  if (whitelabel !== undefined) {
    sessionMemory[SESSION_MEMORY_KEYS.whitelabel] = parseIfString(whitelabel);
  }
  notifyListeners();
}
